import { DataTable } from '../../common/DataTable';
import { StatusBadge } from '../../common/StatusBadge';
import type { Order } from '../../../models/Order';
import { formatDateTime } from '../../../utils/date';

export const OrdersTab = ({ items }: { items: Order[] }) => (
  <DataTable
    items={items}
    columns={[
      { columnId: 'ref', label: 'Reference', renderCell: (item) => item.cr_crm_orderreference ?? '—' },
      { columnId: 'date', label: 'Date', renderCell: (item) => formatDateTime(item.cr_crm_orderedat ?? undefined) },
      { columnId: 'usd', label: 'Total USD', renderCell: (item) => item.cr_crm_totalamountusd != null ? `${item.cr_crm_totalamountusd.toFixed(2)} $` : '—' },
      { columnId: 'total', label: 'Total TND', renderCell: (item) => item.cr_crm_totalamounttnd != null ? `${item.cr_crm_totalamounttnd.toFixed(3)} TND` : item.cr_crm_lineitemcount != null ? `${item.cr_crm_lineitemcount} item(s)` : '—' },
      { columnId: 'status', label: 'Status', renderCell: (item) => <StatusBadge value={item.cr_crm_status} /> },
    ]}
    getRowId={(item) => item.cr_crm_orderid}
    page={1}
    pageCount={1}
    totalItems={items.length}
    onPageChange={() => undefined}
  />
);
